import React, { useEffect, useState } from 'react';
import { Calendar, ListChecks, LogOut, Mail, Moon, Settings, Sun, Users } from 'lucide-react';
import { Mailbox } from './Mailbox.jsx';
import { CalendarPage } from './Calendar.jsx';
import { ContactsPage } from './Contacts.jsx';
import { TasksPage } from './Tasks.jsx';
import { SettingsPage } from './Settings.jsx';

const APPS = [['mail', 'Mail', Mail], ['calendar', 'Calendar', Calendar], ['contacts', 'Contacts', Users], ['tasks', 'Tasks', ListChecks]];

/** Authenticated shell: icon rail + current app. Cross-app intents (compose to contact, open mail from task) go through `intent`. */
export function Shell({ session, theme, onLogout }) {
  const [app, setApp] = useState('mail');
  const [intent, setIntent] = useState(null); // { type: 'compose', to } | { type: 'openMail', emailId }
  const [badges, setBadges] = useState({});
  const initial = (session.name || session.email)[0].toUpperCase();

  useEffect(() => {
    const k = (e) => { if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return; const map = { 'g m': 'mail', 'g c': 'calendar', 'g k': 'contacts', 'g t': 'tasks' }; /* two-key chords handled by Mailbox etc. */ void map; };
    window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k);
  }, []);

  const navigate = (to, i) => { setApp(to); setIntent(i || null); };

  return (
    <div className="km-shell">
      <aside className="km-rail">
        <img src="/brand/mark.svg" width="32" height="32" alt="KryptaMail" style={{ marginBottom: 14 }} />
        {APPS.map(([id, name, Icon]) => (
          <button key={id} className={`km-rail-btn ${app === id ? 'active' : ''}`} title={name} onClick={() => navigate(id)}>
            <Icon size={19} />{badges[id] ? <span className="km-rail-dot" /> : null}
          </button>
        ))}
        <div className="km-rail-bottom">
          <button className="km-rail-btn" title={theme.isDark ? 'Switch to light' : 'Switch to dark'} onClick={theme.toggle}>{theme.isDark ? <Sun size={18} /> : <Moon size={18} />}</button>
          <button className={`km-rail-btn ${app === 'settings' ? 'active' : ''}`} title="Settings" onClick={() => navigate('settings')}><Settings size={18} /></button>
          <button className="km-rail-btn" title="Sign out" onClick={onLogout}><LogOut size={18} /></button>
          <div className="km-rail-avatar" title={session.email}>{initial}</div>
        </div>
      </aside>
      {app === 'mail' && <Mailbox session={session} intent={intent} onBadge={(n) => setBadges((b) => ({ ...b, mail: n }))} />}
      {app === 'calendar' && <CalendarPage session={session} />}
      {app === 'contacts' && <ContactsPage session={session} onCompose={(to) => navigate('mail', { type: 'compose', to })} onOpenMail={(id) => navigate('mail', { type: 'openMail', emailId: id })} />}
      {app === 'tasks' && <TasksPage session={session} onOpenMail={(id) => navigate('mail', { type: 'openMail', emailId: id })} onBadge={(n) => setBadges((b) => ({ ...b, tasks: n }))} />}
      {app === 'settings' && <SettingsPage session={session} theme={theme} />}
    </div>
  );
}
